import { createAggregatedClient } from "@smithy/core/client";
import { BaptizeAmericaClient } from "./BaptizeAmericaClient";
import { AddManagerToChurchCommand, } from "./commands/AddManagerToChurchCommand";
import { CreateAdminUserCommand, } from "./commands/CreateAdminUserCommand";
import { CreateAttendeeUserCommand, } from "./commands/CreateAttendeeUserCommand";
import { CreateBaptismCommand, } from "./commands/CreateBaptismCommand";
import { CreateChurchCommand, } from "./commands/CreateChurchCommand";
import { CreateChurchInvitationCommand, } from "./commands/CreateChurchInvitationCommand";
import { CreateRegistrationCommand, } from "./commands/CreateRegistrationCommand";
import { DeleteBaptismCommand, } from "./commands/DeleteBaptismCommand";
import { DeleteChurchCommand, } from "./commands/DeleteChurchCommand";
import { DeleteCurrentUserCommand, } from "./commands/DeleteCurrentUserCommand";
import { DeleteInvitationCommand, } from "./commands/DeleteInvitationCommand";
import { DeleteRegistrationCommand, } from "./commands/DeleteRegistrationCommand";
import { DeleteUserCommand, } from "./commands/DeleteUserCommand";
import { GetBaptismCommand, } from "./commands/GetBaptismCommand";
import { GetChurchCommand } from "./commands/GetChurchCommand";
import { GetChurchManagerCommand, } from "./commands/GetChurchManagerCommand";
import { GetUserCommand } from "./commands/GetUserCommand";
import { ListBaptismCommand, } from "./commands/ListBaptismCommand";
import { ListChurchCommand, } from "./commands/ListChurchCommand";
import { ListCurrentUserRegistrationCommand, } from "./commands/ListCurrentUserRegistrationCommand";
import { ListInvitationCommand, } from "./commands/ListInvitationCommand";
import { LoadDashboardCommand, } from "./commands/LoadDashboardCommand";
import { RemoveManagerFromChurchCommand, } from "./commands/RemoveManagerFromChurchCommand";
import { SummarizeUsersCommand, } from "./commands/SummarizeUsersCommand";
import { UpdateAnalyticsCommand, } from "./commands/UpdateAnalyticsCommand";
import { UpdateBaptismCommand, } from "./commands/UpdateBaptismCommand";
import { UpdateChurchCommand, } from "./commands/UpdateChurchCommand";
const commands = {
    AddManagerToChurchCommand,
    CreateAdminUserCommand,
    CreateAttendeeUserCommand,
    CreateBaptismCommand,
    CreateChurchCommand,
    CreateChurchInvitationCommand,
    CreateRegistrationCommand,
    DeleteBaptismCommand,
    DeleteChurchCommand,
    DeleteCurrentUserCommand,
    DeleteInvitationCommand,
    DeleteRegistrationCommand,
    DeleteUserCommand,
    GetBaptismCommand,
    GetChurchCommand,
    GetChurchManagerCommand,
    GetUserCommand,
    ListBaptismCommand,
    ListChurchCommand,
    ListCurrentUserRegistrationCommand,
    ListInvitationCommand,
    LoadDashboardCommand,
    RemoveManagerFromChurchCommand,
    SummarizeUsersCommand,
    UpdateAnalyticsCommand,
    UpdateBaptismCommand,
    UpdateChurchCommand,
};
export class BaptizeAmerica extends BaptizeAmericaClient {
}
createAggregatedClient(commands, BaptizeAmerica);
